"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handles a DOM mutation.
 */
var DomMutation =
/**
 * Class constructor.
 *
 * @param {string} attributeName Attribute name.
 * @param {string} [type] Mutation type.
 */
function DomMutation() {
  var attributeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  _classCallCheck(this, DomMutation);

  this.type = type ? type : attributeName !== null ? 'attributes' : 'characterData';
  this.addedNodes = [];
  this.removedNodes = [];
  this.attributeName = attributeName;
};

exports.default = DomMutation;